import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isMobile, isAndroid} from 'react-device-detect';
import BitPaymentComponent from 'app/Components/Shared/BitPayment/BitPaymentComponent';
import {
  handleCurrentStep,
  getBitPaymentStatus,
  getBitPaymentStatusOnLoading,
  openBitRequest,
  setSuccessPage,
  setShowPopup,
  getBitResultStep,
} from './DebtAndUpdatePaymentBlockSlice';
import {getDBBitStatus} from 'app/Components/Shared/BitPayment/bitPaymentSlice';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {bitPaymentStatusEnum, stepEnum, popupEnum} from './Constants/debtPaymentEnum';
import {deviceType} from './Constants/debtPaymentEnum';

export const useDebtPaymentBit = () => {
  const dispatch = useDispatch();
  const paymentAmount = useSelector((s) => s.debtAndUpdatePayment.paymentAmount);
  const selectedBanData = useSelector((s) => s.debtAndUpdatePayment.selectedBanData);
  const currentStep = useSelector((s) => s.debtAndUpdatePayment.currentStep);
  const bitExternalSystemReference = useSelector((s) => s.debtAndUpdatePayment.bitExternalSystemReference);
  const bitExternalRef = useSelector((s) => s.bitPayment.externalSystemReference);
  const email = useSelector((s) => s.authentication.loginData?.userDetails?.CustomerEmail);
  const state = {paymentAmount, selectedBanData, currentStep, bitExternalSystemReference};
  const bitPaymentOption = useSelector((s) => s.debtAndUpdatePayment.bitPaymentOption);
  const bit = {externalSystemReference: bitExternalRef};

  const openBitRequestHandler = () => {
    const request = {
      paymentAmount: state.paymentAmount,
      ban: state.selectedBanData.banNumber,
      paymentSubject: 0,
      device: !isMobile ? deviceType.DESKTOP : isAndroid ? deviceType.ANDROID : deviceType.IOS,
      totalAmount: state.selectedBanData.amount,
      billByEmail: true,
      customerEmail: email,
    };
    dispatch(openBitRequest(request));
  };

  const validateBitRequest = () => {
    dispatch(
      getBitPaymentStatus({
        ban: state.selectedBanData.banNumber,
        externalSystemReference: bit.externalSystemReference || state.bitExternalSystemReference,
      }),
    );
  };

  const validateStatusOnPending = () => {
    dispatch(
      getBitPaymentStatusOnLoading({
        ban: state.selectedBanData.banNumber,
        externalSystemReference: bit.externalSystemReference || state.bitExternalSystemReference,
      }),
    );
  };

  const getPaymentStatusesForBan = async (item) => {
    dispatch(showAppLoader());
    try {
      const action = await dispatch(getDBBitStatus(item?.banNumber || item));
      const res = action.payload;
      dispatch(hideAppLoader());
      if (res?.status) {
        if (res.status == 'New') {
          if (state.currentStep === stepEnum.BANSELECT) {
            dispatch(handleCurrentStep(stepEnum.SELECTAMOUNT));
          } else if (
            state.currentStep === stepEnum.SELECTPAYMENTTYPE ||
            state.currentStep === stepEnum.CREDITCARD ||
            state.currentStep === stepEnum.PAYMENTFAILED
          ) {
            openBitRequestHandler();
          }
        } else {
          if (res.status.toLowerCase() == bitPaymentStatusEnum.BITPENDING) {
            dispatch(setShowPopup({show: true, popupType: popupEnum.BIT_PENDING}));
          } else {
            const nextStep = getBitResultStep(res.status, res.statusCode);
            const debtAmount = item?.amount ?? state.selectedBanData?.amount;
            const paymentAmount = res.paymentAmount;
            if (nextStep == stepEnum.PAYMENTSUCCESS) {
              const successPagedata = {
                receptionNo: res.receptionNo,
                paymentAmount,
                debtAmount,
                credit4Digits: res.credit4Digits,
                customerEmail: res.customerEmail || email,
              };
              dispatch(setSuccessPage(successPagedata));
            }
            dispatch(handleCurrentStep(nextStep));
          }
        }
      } else {
        dispatch(handleCurrentStep(stepEnum.BITGENERALERROR));
      }
    } catch {
      dispatch(hideAppLoader());
      dispatch(handleCurrentStep(stepEnum.BITGENERALERROR));
    }
  };

  return {
    getPaymentStatusesForBan,
    validateBitRequest,
    validateStatusOnPending,
  };
};

/**
 * Wrapper for BitPaymentComponent. Uses useDebtPaymentBit() internally.
 * Props: ban, paymentAmount, bitReturnEvent, bitIsReady
 */
export const DebtPaymentBitWrapper = ({ban, paymentAmount, bitReturnEvent, bitIsReady}) => {
  const {validateBitRequest, validateStatusOnPending} = useDebtPaymentBit();

  if (!(bitIsReady || bitReturnEvent)) {
    return null;
  }

  return (
    <BitPaymentComponent
      bitReturnEvent={bitReturnEvent}
      actionOnPaymentPending={validateStatusOnPending}
      actionOnPaymentCompleted={validateBitRequest}
      ban={ban}
      paymentAmount={paymentAmount}
    />
  );
};
